import { IAppState } from 'shared/common/state';

export const earlyAccessReducer = (state: IAppState): IAppState => {
  return {
    ...state,
    earlyAccessData: state.earlyAccessData,
  };
};
